module.exports = __webpack_public_path__ + "img/service-04.c160393f.png";